import Vue from 'vue';
import I18nPlugin from '@exporo/educts-component-i18n';
import LocalStorage from '@/utils/LocalStorage';

declare module 'vue/types/vue' {
  interface Vue {
    $i18n: any,
    $t: any
  }
}

const locale = LocalStorage.has('i18nextLng') 
    ? LocalStorage.get('i18nextLng') 
    : 'de-DE';

export function configI18n() {
  Vue.use(I18nPlugin);

  // educts pluggin overrides localstorage with 'fallbackLng' so we need to set it back
  const { $i18n } = Vue.prototype;

  $i18n.on('initialized', (options) => {
    $i18n.language = locale;
    $i18n.locale = locale;
    $i18n.fallbackLng = locale;
    $i18n.changeLanguage(locale);
  });
}
